import React from 'react';
import { Button } from './ui/Button';
import { FadeIn } from './ui/FadeIn';
import { ShieldCheck, ArrowRight } from 'lucide-react';
export function Pricing() {
  return <section id="precio" className="py-24 bg-[#faf8f5]" data-id="element-110">
      <div className="container mx-auto px-6 max-w-3xl" data-id="element-111">
        <FadeIn data-id="element-112">
          <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border border-gray-100" data-id="element-113">
            <div className="bg-[#1a1f3a] p-8 text-center text-white" data-id="element-114">
              <h2 className="text-2xl md:text-3xl font-serif font-bold mb-2" data-id="element-115">
                Guía de Reinicio de Energía
              </h2>
              <p className="text-[#d4a574] font-medium" data-id="element-116">Para la Mediana Edad</p>
            </div>

            <div className="p-8 md:p-12 text-center" data-id="element-117">
              <p className="text-gray-600 mb-8 text-lg" data-id="element-118">
                Protocolo completo de 21 días <br data-id="element-119" />
                <span className="text-sm text-gray-400" data-id="element-120">
                  (con plantillas y checklists)
                </span>
              </p>

              <div className="flex items-center justify-center mb-8" data-id="element-121">
                <span className="text-2xl text-gray-400 line-through mr-4" data-id="element-122">
                  $29
                </span>
                <span className="text-5xl font-bold text-[#1a1f3a]" data-id="element-123">$6.39</span>
                <span className="text-gray-400 ml-2 text-sm" data-id="element-124">USD</span>
              </div>

              <div className="bg-[#8da399]/20 text-[#1a1f3a] px-4 py-2 rounded-full text-sm font-medium mb-6 inline-block" data-id="element-125">
                ¡Oferta especial! Ahorra más del 75%
              </div>

              <Button fullWidth className="text-lg py-6 mb-6 group" onClick={() => window.open('https://www.yaneladigitalab.com/cart/43795917996167:1', '_blank')} data-id="element-126">
                Quiero recuperar energía estable
                <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-127" />
              </Button>

              <div className="flex items-center justify-center text-sm text-gray-500 gap-2" data-id="element-128">
                <ShieldCheck className="w-4 h-4 text-[#8da399]" data-id="element-129" />
                <span data-id="element-130">Pago seguro y acceso inmediato</span>
              </div>
            </div>

            <div className="bg-gray-50 p-6 text-center border-t border-gray-100" data-id="element-131">
              <p className="text-gray-600 font-medium" data-id="element-132">
                Si quieres dejar de sobrevivir el día y volver a habitarlo, este
                es tu siguiente paso.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}